import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const msg: string = 'Please, select at least one Service Status'
const schema = yup.object({
  section_1: yup.array().min(1, msg).required(msg),
  section_2: yup.array().min(1, msg).required(msg),
})

const resReportConfiguration = yupResolver(schema)

export default resReportConfiguration
